import * as React from "react";
import cx from "classnames";

export interface SummaryRowProps {
  iconClass?: string;
  headerText: string;
  children?: React.ReactChild;
}

const SummaryRow = (props: SummaryRowProps) => (
  <li className="summary__row">
    <span
      className={cx("summary__header", {
        "summary__header--has-icon": props.iconClass,
      })}
    >
      {props.iconClass && (
        <i className={cx("summary__icon", props.iconClass)} />
      )}
      {props.headerText}
    </span>
    <span className="summary__value">{props.children}</span>
  </li>
);

export default SummaryRow;



// WEBPACK FOOTER //
// ./src/routes/WizardSummary/components/SummaryRow.tsx